import { render, staticRenderFns } from "./PortalOfficeReviewSearchBox.vue?vue&type=template&id=8574f14c&scoped=true&"
import script from "./PortalOfficeReviewSearchBox.vue?vue&type=script&lang=ts&"
export * from "./PortalOfficeReviewSearchBox.vue?vue&type=script&lang=ts&"
import style0 from "./PortalOfficeReviewSearchBox.vue?vue&type=style&index=0&id=8574f14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8574f14c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
